import React from 'react';
import { useIntl } from 'umi';
import classnames from 'classnames';
import EllipsisHover from '@/pages/home/components/EllipsisHover';
import { addFormatMessageSafelyHandler } from '../../../../utils';

import './index.scss';

import type { IBaseProps } from '@/pages/intelligence/types/common';

interface IEntitiesMetricsSummaryBarProps extends IBaseProps {
  columns: number;
  metrics: string[];
  metricsNamesMapping: {
    [key: string]: string;
  };
  metricsNamesTooltipMapping: {
    [key: string]: string;
  };
  showKeyMetricsWhenOnlyOne?: boolean;
  keyMetricsText?: string;
  placeholder?: string;
}

export default function EntitiesMetricsSummaryBar(props: IEntitiesMetricsSummaryBarProps) {
  const { formatMessage } = useIntl();
  const formatMessageSafely = addFormatMessageSafelyHandler(formatMessage);

  const {
    columns,
    metrics,
    metricsNamesMapping,
    metricsNamesTooltipMapping,
    showKeyMetricsWhenOnlyOne = true,
    keyMetricsText = formatMessage({ id: 'dbi_key_metrics' }),
    placeholder = '-',
    style,
    className,
  } = props;

  const isMulti = metrics?.length > 1;

  const renderOneMetricUI = () => {
    const text = showKeyMetricsWhenOnlyOne
      ? keyMetricsText
      : formatMessageSafely({ id: metricsNamesMapping?.[metrics?.[0]] });

    return <div className="dbi-entities_column">{text || metrics?.[0] || placeholder}</div>;
  };

  return (
    <div
      style={style}
      className={classnames('dbi-entities_metrics-summary-bar dbi-entities_row', className, { 'is-multi': isMulti })}
    >
      {metrics?.length === 1 && renderOneMetricUI()}
      {isMulti &&
        Array.from({ length: columns + 1 })?.map((item, i) => {
          if (i === 0) return <div key={i} className="dbi-entities_column first-column"></div>;
          return (
            <div key={i} className="dbi-entities_column">
              {metrics?.map((metric, metricI) => {
                const metricNameLocaleKey = metricsNamesMapping?.[metric];
                const textBubbleLocaleKey = metricsNamesTooltipMapping?.[metric] || metricNameLocaleKey;
                const text = formatMessageSafely({ id: metricNameLocaleKey });
                const textBubble = formatMessageSafely({ id: textBubbleLocaleKey });
                return (
                  <div key={metricI} className="dbi-entities_child-column">
                    <EllipsisHover
                      text={text || metric || placeholder}
                      textBubble={textBubble || metric || placeholder}
                    />
                  </div>
                );
              })}
            </div>
          );
        })}
    </div>
  );
}
